import { CountryCodes } from '@/enums/general'

export interface PaymentType {
  name: string
  value: string
  paymentType: string
  verificationAmount: number
}

export const paynlIdeal: PaymentType = {
  name: 'iDEAL',
  value: 'paynl-ideal',
  paymentType: '/api/payment_types/code/paynl-ideal',
  verificationAmount: 0.02
}

export const paynlEPS: PaymentType = {
  name: 'EPS',
  value: 'paynl-eps',
  paymentType: '/api/payment_types/code/paynl-eps',
  verificationAmount: 0.01
}

export const paypal: PaymentType = {
  name: 'PayPal',
  value: 'braintree-paypal',
  paymentType: '/api/payment_types/code/braintree-paypal',
  verificationAmount: 0
}

export const paynlBancontact: PaymentType = {
  name: 'Bancontact',
  value: 'paynl-bancontact',
  paymentType: '/api/payment_types/code/paynl-bancontact',
  verificationAmount: 0.02
}

export const braintreeCreditCard: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.creditcard',
  value: 'braintree-creditcard',
  paymentType: '/api/payment_types/code/braintree-creditcard',
  verificationAmount: 1.00
}

export const paynlGiropay: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.giropay',
  value: 'paynl-giropay',
  paymentType: '/api/payment_types/code/paynl-giropay',
  verificationAmount: 0.01
}

export const braintreeApplePay: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.applepay',
  value: 'braintree-applepay',
  paymentType: '/api/payment_types/code/braintree-applepay',
  verificationAmount: 0
}

export const braintreeGooglePay: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.googlepay',
  value: 'braintree-googlepay',
  paymentType: '/api/payment_types/code/braintree-googlepay',
  verificationAmount: 0
}

export const Icons = Object.freeze({
  ideal: ['ideal'],
  sepa: ['sepa'],
  'paynl-ideal': ['ideal'],
  bancontact: ['bancontact'],
  'paynl-bancontact': ['bancontact'],
  creditcard: ['visa', 'maestro', 'mastercard'],
  'braintree-creditcard': ['visa', 'maestro', 'mastercard'],
  paypal: ['paypal'],
  'braintree-paypal': ['paypal'],
  'paynl-eps': ['eps'],
  'paynl-giropay': ['giropay'],
  'braintree-applepay': ['apple-pay'],
  'braintree-googlepay': ['google-pay']
})

export interface IssuerType {
  label: string
  issuerId: number
  svg: string
}

export const IdealIssuers = Object.freeze({
  abnamro: {
    label: 'ABN AMRO',
    issuerId: 10,
    svg: 'ABNA'
  },
  asnbank: {
    label: 'ASN Bank',
    issuerId: 50,
    svg: 'ASNB'
  },
  bunq: {
    label: 'Bunq',
    issuerId: 110,
    svg: 'BUNQ'
  },
  ingbank: {
    label: 'ING Bank',
    issuerId: 30,
    svg: 'INGB'
  },
  knab: {
    label: 'Knab',
    issuerId: 80,
    svg: 'KNAB'
  },
  n26: {
    label: 'N26',
    issuerId: 230,
    svg: 'n26'
  },
  nationaleNederlanden: {
    label: 'Nationale Nederlanden',
    issuerId: 210,
    svg: 'nationale-nederlanden'
  },
  rabobank: {
    label: 'Rabobank',
    issuerId: 20,
    svg: 'RABO'
  },
  regiobank: {
    label: 'Regiobank',
    issuerId: 60,
    svg: 'RBRB'
  },
  revolut: {
    label: 'Revolut',
    issuerId: 200,
    svg: 'REVOLUT'
  },
  snsbank: {
    label: 'SNS Bank',
    issuerId: 40,
    svg: 'SNSB'
  },
  triodosbank: {
    label: 'Triodos bank',
    issuerId: 70,
    svg: 'TRIO'
  },
  vanlanschotbankiers: {
    label: 'Van Lanschot Bankiers',
    issuerId: 100,
    svg: 'FVLB'
  },
  yoursafe: {
    label: 'Yoursafe',
    issuerId: 220,
    svg: 'yoursafe'
  }
})

export const PaymentStatuses = Object.freeze({
  open: 0,
  paid: 1,
  failed: 2,
  chargeBack: 3,
  latePayment: 4,
  pending: 5,
  refund: 6,
  paidLate: 7,
  waste: 66
})

export const PaymentDates = Object.freeze({
  [CountryCodes.austria]: 25,
  [CountryCodes.belgium]: 20,
  [CountryCodes.denmark]: 26,
  [CountryCodes.germany]: 25,
  [CountryCodes.spain]: 26,
  [CountryCodes.france]: 26,
  [CountryCodes.netherlands]: 20,
  [CountryCodes.unitedKingdom]: 26,
  [CountryCodes.sweden]: 26,
  [CountryCodes.italy]: 26,
  [CountryCodes.poland]: 26,
  [CountryCodes.switzerland]: 26,
  [CountryCodes.ireland]: 26,
  [CountryCodes.luxembourg]: 25,
  [CountryCodes.portugal]: 26,
  [CountryCodes.finland]: 26,
  [CountryCodes.norway]: 26,
  [CountryCodes.czechRepublic]: 26
})

export const BraintreeResponseTypes = Object.freeze({
  no3DSecureAvailable: 'authentication_unavailable'
})

export const PaymentFeatureFlagCookieQuery = 'ota-payment'
